/** During build process, the current version will be injected here */
export const VERSION = typeof '15.38.1' !== 'undefined' ? '15.38.1' : 'unknown';
